import {ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy} from '@angular/router';
import {ComponentRef} from '@angular/core';

interface StoredRoute {
    route: ActivatedRouteSnapshot;
    handle: DetachedRouteHandle;
}

function getFullPath(route: ActivatedRouteSnapshot): string {
    return route.pathFromRoot
        .map(v => v.url.map(segment => segment.toString()).join('/'))
        .join('/')
        .trim()
        .replace(/\/$/, ''); // Remove trailing slash
}


export class RouteReuseService implements RouteReuseStrategy {

    storedRoutes: Record<string, StoredRoute> = {};

    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        return !!route.data.storeRoute;
    }

    store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
        const key = getFullPath(route);
        this.storedRoutes[key] = { route, handle };
    }

    shouldAttach(route: ActivatedRouteSnapshot): boolean {
        const key = getFullPath(route);
        return !!route.routeConfig && !!this.storedRoutes[key];
    }

    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
        const key = getFullPath(route);
        if (!route.routeConfig || !this.storedRoutes[key]) { return null; }
        return this.storedRoutes[key].handle;
    }

    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        const isSameConfig = future.routeConfig === curr.routeConfig;
        const shouldReuse = !curr.data.noReuse;
        return isSameConfig && shouldReuse;
    }

    clearAllRoutes() {
        for (const key in this.storedRoutes) {
            if (this.storedRoutes.hasOwnProperty(key)) {
                this.destroyComponent(this.storedRoutes[key].handle);
            }
        }
        this.storedRoutes = {};
    }

    private destroyComponent(handle: DetachedRouteHandle): void {
        const componentRef: ComponentRef<any> = handle && handle["componentRef"];
        if (componentRef) {
            componentRef.destroy();
        }
    }
}
